import React from "react";
import "../css/generalDetails.css";

const GeneralDetails = ({
  invoiceNo = "",
  opdNo = "",
  mobileNo = "",
  fullName = "",
  appointmentNo = ""
}) => {
  return (
    <div className="w-full flex justify-between text-[#000000] text-[12px] pb-3">
      <div className="flex flex-col gap-3">
        <span className="leading-[13.8px] font-bold">{fullName}</span>
        <span className="leading-[13.8px]">{mobileNo}</span>
      </div>
      <div className="flex flex-col gap-3">
        <span className="leading-[13.8px]">{invoiceNo}</span>
        {opdNo && (
          <span className="leading-[13.8px]">{`OPD No. ${opdNo}`}</span>
        )}
        <span className="leading-[13.8px]">{`Appointment No. ${appointmentNo}`}</span>
      </div>
    </div>
  );
};

export default GeneralDetails;
